import { createChat } from 'https://cdn.jsdelivr.net/npm/@n8n/chat/dist/chat.bundle.es.js';

document.addEventListener('turbo:load', function() {
  createChat({
    webhookUrl: 'https://ai.eventya.net/webhook/fb4133d2-f540-48b7-aec4-2d3653aa39b2/chat',
    showWelcomeScreen: false,
    target: '#chatbot',
    defaultLanguage: 'ro',
    loadPreviousSession: false,
    initialMessages: [
      'Salutare 👋, cu ce te pot ajuta?'
    ],
    i18n: {
      ro: {
        title: 'Chatbot',
        subtitle: 'Menționăm că răspunsurile sunt generate de inteligența artificială, însă trimiterile sunt către documente de pe site. Dacă nu găsiți totuși răspunsul, vă rugăm să ne contactați prin formularul de HELPDESK – de la secțiunea Contact',
        getStarted: 'Incepe',
        inputPlaceholder: 'Scrie un mesaj...',
      },
    },
  });
});
